<template>
    <van-tabs class="form-view-container" :lazy-render="false" :ellipsis="false">
        <van-tab v-for="viewObj in viewList" :title="viewObj.name" :key="viewObj.id">
            <cgs-app-form ref="tableView" :worksheetDetail="worksheetDetail" :viewId="viewObj.id" :hiddenFields="viewObj.hiddenFields" @deleteRowIds="deleteViewRow">
            </cgs-app-form>
        </van-tab>
    </van-tabs>
</template>

<script>
    import {
        Tab,
        Tabs
    } from 'vant';
    import cgsAppForm from "./appForm.vue";

    export default {
        components: {
            vanTabs: Tabs,
            vanTab: Tab,
            cgsAppForm
        },
        props: {
            worksheetDetail: {
                type: Object,
                default: () => {
                    return {}
                }
            }
        },
        data() {
            return {}
        },
        mounted() {
            console.log(this.worksheetDetail)
        },
        computed: {
            viewList: {
                get() {
                    let _list = []
                    if ('viewList' in this.worksheetDetail) {
                        _list = this.worksheetDetail.viewList
                    }
                    return _list
                },
                set() {}
            }
        },
        watch: {
            worksheetDetail() {
                console.log(this.worksheetDetail)
            }
        },
        methods: {
            deleteViewRow(ids){
                this.$refs.tableView.forEach(item => {
                    item.delWorksheetRows(ids)
                })
            }
        }
    }
</script>

<style>
    .form-view-container.van-tabs {
        height: 100%;
    }

    .form-view-container .van-tabs__content {
        height: calc(100% - 44px);
    }

    .form-view-container .van-tab__pane {
        height: 100%;
    }

    .form-view-container .van-tab {
        flex: unset;
        margin: 0px 10px;
    }

    .form-view-container .van-cell-group {
        background: unset;
    }

    .form-view-container .van-tabs__line {
        background-color: rgba(33, 150, 243, 1);
    }
</style>